/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import RemoveAssetFromProjectForm from './RemoveAssetFromProjectForm/RemoveAssetFromProjectForm';
import RemoveAssetFromProjectSuccess from './RemoveAssetFromProjectSuccess/RemoveAssetFromProjectSuccess';
import RemoveAssetFromProjectError from './RemoveAssetFromProjectError/RemoveAssetFromProjectError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveAssetFromProject extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const fields: Array<Object> = [
      /*
            {
                name: 'removeAssetProjects',
                label: 'Select project(s) to remove from',
                fields: [
                    {
                        name: 'projects',
                        label: 'Projects',
                        rules: 'required|array',
                        value: [],
                        placeholder: 'Project code or name...'
                    }
                ]
            },
            */
      {
        name: 'removeAssetReason',
        label: t('general:assets.reasons.why_remove'),
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_removing_assets'),
            rules: 'required|string',
            value: '',
            options: [
              {
                id: '1',
                label: t('general:reasons.options.asset_no_longer_required'),
              },
              {
                id: '2',
                label: t('general:reasons.options.asset_required_on_new_project'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        //const {
        //    projects
        //}: Object = data.values().removeAssetProjects;

        const { reason }: Object = data.values().removeAssetReason;

        actionDrawerStore.removeAssetFromProject(asset.id, {
          //projects,
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'removeAssetFromProject',
      }
    );
  };

  render(): React.Node {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const title: string = t('general:actions.remove_asset_from_project');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <RemoveAssetFromProjectError asset={asset} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <RemoveAssetFromProjectSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <RemoveAssetFromProjectForm asset={asset} form={this.createForm()} />
      </div>
    );
  }
}
